import React, { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { damga, yazdirBaslikli } from "../lib/stamp";
import { Printer, Cog, Flame, Download, Boxes } from "lucide-react";

const fmt = (n) => (n == null ? "0" : Number(n).toLocaleString("tr-TR"));
const esc = (v) => String(v ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

function DetayTablo({ title, icon: Icon, labelCol, rows, testid }) {
  const toplamAdet = rows.reduce((s, r) => s + (Number(r.adet) || 0), 0);
  const toplamKg = rows.reduce((s, r) => s + (Number(r.kg) || 0), 0);
  return (
    <div className="border border-zinc-200 bg-white rounded-sm overflow-hidden" data-testid={testid}>
      <div className="flex items-center gap-2 px-4 py-2.5 bg-zinc-800 text-white font-head font-bold text-sm uppercase tracking-wide">
        <Icon size={16} /> {title}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full data-table">
          <thead>
            <tr>
              <th>{labelCol}</th>
              <th className="w-40 text-center">Adet</th>
              <th className="w-44 text-center">KG Ağırlık</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={3} className="text-center py-8 text-zinc-400">Seçilen aralıkta kayıt yok.</td></tr>
            ) : rows.map((r, i) => (
              <tr key={i} className={i % 2 ? "bg-zinc-50/60" : "bg-white"}>
                <td className="font-semibold text-zinc-900">{r.makina || r.bolge}</td>
                <td className="num font-semibold text-center">{fmt(r.adet)}</td>
                <td className="num text-amber-700 font-semibold text-center">{fmt(r.kg)} kg</td>
              </tr>
            ))}
          </tbody>
          {rows.length > 0 && (
            <tfoot>
              <tr className="bg-zinc-100 font-bold">
                <td>TOPLAM</td>
                <td className="num text-center">{fmt(toplamAdet)}</td>
                <td className="num text-amber-800 text-center">{fmt(Math.round(toplamKg * 10) / 10)} kg</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </div>
  );
}

function BolumTablo({ rows, testid }) {
  const isLogo = (r) => String(r.bolum || "").trim().toLowerCase() === "logo";
  const t = rows.reduce((a, r) => (isLogo(r) ? a : {
    ya: a.ya + (Number(r.yapilan_adet) || 0), fa: a.fa + (Number(r.fire_adet) || 0), ta: a.ta + (Number(r.toplam_adet) || 0),
    yk: a.yk + (Number(r.yapilan_kg) || 0), fk: a.fk + (Number(r.fire_kg) || 0), tk: a.tk + (Number(r.toplam_kg) || 0),
  }), { ya: 0, fa: 0, ta: 0, yk: 0, fk: 0, tk: 0 });
  const r1 = (n) => Math.round((Number(n) || 0) * 10) / 10;
  const hasLogo = rows.some(isLogo);
  return (
    <div className="border border-zinc-200 bg-white rounded-sm overflow-hidden" data-testid={testid}>
      <div className="flex items-center gap-2 px-4 py-2.5 bg-zinc-800 text-white font-head font-bold text-sm uppercase tracking-wide">
        <Boxes size={16} /> Yapılan Ürün — Bölüm Bazında (Gerçek KG)
      </div>
      <div className="overflow-x-auto">
        <table className="w-full data-table">
          <thead>
            <tr>
              <th>Bölüm</th>
              <th className="text-center">Yapılan Adet</th><th className="text-center">Fire Adet</th><th className="text-center">Toplam Adet</th>
              <th className="text-center">Yapılan KG</th><th className="text-center">Fire KG</th><th className="text-center">Toplam KG</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={7} className="text-center py-8 text-zinc-400">Seçilen aralıkta kayıt yok.</td></tr>
            ) : rows.map((r, i) => (
              <tr key={i} className={isLogo(r) ? "bg-amber-50/70" : (i % 2 ? "bg-zinc-50/60" : "bg-white")}>
                <td className="font-semibold text-zinc-900">
                  {r.bolum}
                  {isLogo(r) && <span className="ml-2 text-[10px] font-semibold text-amber-700 bg-amber-100 border border-amber-200 rounded px-1.5 py-0.5 align-middle">toplama dahil değil</span>}
                </td>
                <td className="num text-center font-semibold text-emerald-700">{fmt(r.yapilan_adet)}</td>
                <td className="num text-center text-red-600">{fmt(r.fire_adet)}</td>
                <td className="num text-center font-semibold">{fmt(r.toplam_adet)}</td>
                <td className="num text-center text-emerald-700">{fmt(r.yapilan_kg)} kg</td>
                <td className="num text-center text-red-600">{fmt(r.fire_kg)} kg</td>
                <td className="num text-center text-amber-700 font-semibold">{fmt(r.toplam_kg)} kg</td>
              </tr>
            ))}
          </tbody>
          {rows.length > 0 && (
            <tfoot>
              <tr className="bg-zinc-100 font-bold">
                <td>TOPLAM{hasLogo ? " (Logo hariç)" : ""}</td>
                <td className="num text-center text-emerald-800">{fmt(t.ya)}</td>
                <td className="num text-center text-red-700">{fmt(t.fa)}</td>
                <td className="num text-center">{fmt(t.ta)}</td>
                <td className="num text-center text-emerald-800">{fmt(r1(t.yk))} kg</td>
                <td className="num text-center text-red-700">{fmt(r1(t.fk))} kg</td>
                <td className="num text-center text-amber-800">{fmt(r1(t.tk))} kg</td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
      {hasLogo && (
        <div className="px-4 py-2 text-[11px] text-zinc-500 border-t border-zinc-100">
          Not: <b className="text-amber-700">Logo</b> bölümü önce üretilip diğer bölümlere teslim edildiğinden mükerrer sayımı önlemek için toplama dahil edilmez; adet ve KG bilgi amaçlı gösterilir.
        </div>
      )}
    </div>
  );
}

export default function KgReport() {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [data, setData] = useState({ sekillenen: [], kalite: [], bolum: [] });

  const load = (s, e) => {
    const p = {};
    if (s) p.start = s;
    if (e) p.end = e;
    api.get("/reports/kg-detay", { params: p }).then((r) => setData(r.data)).catch(() => {});
  };
  useEffect(() => { load("", ""); }, []);

  const exportExcel = () => {
    const section = (title, labelCol, rows) => {
      const ta = rows.reduce((s, r) => s + (Number(r.adet) || 0), 0);
      const tk = rows.reduce((s, r) => s + (Number(r.kg) || 0), 0);
      let b = `<tr><td colspan="3" style="background:#18181B;color:#fff;font-weight:bold;">${esc(title)}</td></tr>`;
      b += `<tr style="background:#E9E9E9;font-weight:bold;"><th>${esc(labelCol)}</th><th>Adet</th><th>KG Ağırlık</th></tr>`;
      rows.forEach((r) => { b += `<tr><td>${esc(r.makina || r.bolge)}</td><td>${Number(r.adet) || 0}</td><td>${Number(r.kg) || 0}</td></tr>`; });
      b += `<tr style="background:#FFF2CC;font-weight:bold;"><td>TOPLAM</td><td>${ta}</td><td>${Math.round(tk * 10) / 10}</td></tr>`;
      b += `<tr><td colspan="3"></td></tr>`;
      return b;
    };
    const body = section("Şekillenen Ürünler — Makina Bazında", "Makina", data.sekillenen || [])
      + section("Kalite Takibinden Geçen — Fırın Bölgesi Bazında", "Fırın Bölgesi", data.kalite || [])
      + (() => {
          const rows = data.bolum || [];
          const isLogo = (r) => String(r.bolum || "").trim().toLowerCase() === "logo";
          const t = rows.reduce((a, r) => (isLogo(r) ? a : { ya: a.ya + (+r.yapilan_adet || 0), fa: a.fa + (+r.fire_adet || 0), ta: a.ta + (+r.toplam_adet || 0), yk: a.yk + (+r.yapilan_kg || 0), fk: a.fk + (+r.fire_kg || 0), tk: a.tk + (+r.toplam_kg || 0) }), { ya: 0, fa: 0, ta: 0, yk: 0, fk: 0, tk: 0 });
          const hasLogo = rows.some(isLogo);
          let b = `<tr><td colspan="7" style="background:#18181B;color:#fff;font-weight:bold;">Yapılan Ürün — Bölüm Bazında (Gerçek KG)</td></tr>`;
          b += `<tr style="background:#E9E9E9;font-weight:bold;"><th>Bölüm</th><th>Yapılan Adet</th><th>Fire Adet</th><th>Toplam Adet</th><th>Yapılan KG</th><th>Fire KG</th><th>Toplam KG</th></tr>`;
          rows.forEach((r) => { b += `<tr${isLogo(r) ? ' style="background:#FFF7E6;"' : ''}><td>${esc(r.bolum)}${isLogo(r) ? " (toplama dahil değil)" : ""}</td><td>${+r.yapilan_adet || 0}</td><td>${+r.fire_adet || 0}</td><td>${+r.toplam_adet || 0}</td><td>${+r.yapilan_kg || 0}</td><td>${+r.fire_kg || 0}</td><td>${+r.toplam_kg || 0}</td></tr>`; });
          b += `<tr style="background:#FFF2CC;font-weight:bold;"><td>TOPLAM${hasLogo ? " (Logo hariç)" : ""}</td><td>${t.ya}</td><td>${t.fa}</td><td>${t.ta}</td><td>${Math.round(t.yk * 10) / 10}</td><td>${Math.round(t.fk * 10) / 10}</td><td>${Math.round(t.tk * 10) / 10}</td></tr>`;
          return b;
        })();
    const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="utf-8"></head><body><table border="1">${body}</table></body></html>`;
    const blob = new Blob(["\ufeff", html], { type: "application/vnd.ms-excel" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `KG Detay Raporu - ${damga()}.xls`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <PageHeader
        title="KG Detay Raporu"
        subtitle="Şekillenen ürünler (makina bazında) ve kalite takibinden geçen ürünler (fırın bölgesi bazında)"
        actions={
          <div className="flex items-center gap-2">
            <button onClick={exportExcel} data-testid="export-btn"
              className="flex items-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-zinc-700 text-sm font-semibold px-3 py-2 rounded-sm">
              <Download size={15} /> Excel'e Aktar
            </button>
            <button onClick={() => yazdirBaslikli("KG Detay Raporu")} data-testid="print-btn"
              className="flex items-center gap-2 border border-zinc-300 hover:bg-zinc-50 text-zinc-700 text-sm font-semibold px-3 py-2 rounded-sm">
              <Printer size={15} /> PDF / Yazdır
            </button>
          </div>
        }
      />
      <div className="p-6 space-y-6 print-area" data-testid="kg-detay-page">
        <div className="border border-zinc-200 bg-white rounded-sm p-4 flex items-end gap-2 flex-wrap">
          <div>
            <label className="block text-[10px] font-semibold text-zinc-500 uppercase mb-0.5">Başlangıç Tarihi</label>
            <input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="kg-start"
              className="border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono" />
          </div>
          <div>
            <label className="block text-[10px] font-semibold text-zinc-500 uppercase mb-0.5">Bitiş Tarihi</label>
            <input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="kg-end"
              className="border border-zinc-300 rounded-sm px-2 py-1.5 text-sm mono" />
          </div>
          <button onClick={() => load(start, end)} data-testid="kg-filter-btn"
            className="bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold px-4 py-1.5 rounded-sm">Filtrele</button>
          <button onClick={() => { setStart(""); setEnd(""); load("", ""); }} data-testid="kg-clear-btn"
            className="border border-zinc-300 hover:bg-zinc-50 text-zinc-600 text-sm font-semibold px-4 py-1.5 rounded-sm">Temizle</button>
        </div>

        <DetayTablo title="Şekillenen Ürünler — Makina Bazında" icon={Cog}
          labelCol="Makina" rows={data.sekillenen} testid="table-sekillenen" />

        <DetayTablo title="Kalite Takibinden Geçen — Fırın Bölgesi Bazında" icon={Flame}
          labelCol="Fırın Bölgesi" rows={data.kalite} testid="table-kalite" />

        <BolumTablo rows={data.bolum || []} testid="table-bolum" />
      </div>
    </>
  );
}
